import { AddPlusButton } from '@components/core-ui/buttons/AddPlusButton';

import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { Plan } from './components/Plan';
import { Wrapper } from './styles/Wrapper';
import { TProps } from './types/TProps';

export const Plans = ({ plans, onChange }: TProps) => {
  const { me } = useAuthContext();
  const { openModal } = useModalContext();
  const isVsBilling = me?.roles?.includes('ROLE_BILLING_ADMIN');
  if (!plans) {
    return <></>;
  }

  const onAddOne = () => {
    openModal(ModalNamesEnum.AddNewASOnePlan, {
      onSuccess: () => onChange(),
    });
  };

  return (
    <Wrapper className="plans-wrapper">
      <ul className="list">
        {plans.map((p) => (
          <li key={p.id}>
            <Plan plan={p} onChange={() => onChange()} />
          </li>
        ))}
        {isVsBilling ? <AddPlusButton onClick={onAddOne} variant="avatar" ariaLabel="Add plan" /> : null}
      </ul>
    </Wrapper>
  );
};
